import _ from "lodash";
import { ReactElement } from "react";

import { palette } from "~frontend/theme";
import { formatDollars } from "~frontend/util/formatDollars";

import { Chart } from "./Chart";
import { ChartContainer } from "./ChartContainer";
import { Month } from "./monthlyBuckets";

type Data = {
  month: Month;
  averageDonationDollars?: number;
  averageFirstWeekDonationDollars?: number;
}[];

export function MonthlyAverageDonationChart({
  data,
}: {
  data: Data | null;
}): ReactElement {
  return (
    <ChartContainer
      title="Monthly Average Donation"
      loading={!data}
      downloadableRows={data?.map(r => ({
        month: r.month.toString(),
        averageDonationDollars: (r.averageDonationDollars ?? 0).toFixed(2),
        averageFirstWeekDonationDollars: (
          r.averageFirstWeekDonationDollars ?? 0
        ).toFixed(2),
      }))}
      downloadFileName="monthlyAverageDonations.csv"
      empty={data?.length === 0}
    >
      <Chart
        data={data ?? []}
        series={[
          {
            type: "line",
            yAxisId: "averageDonation",
            label: "Full Campaign",
            color: palette.navy,
            getValue: d => d.averageDonationDollars ?? 0,
          },
          {
            type: "line",
            yAxisId: "averageDonation",
            label: "First Week",
            color: palette.darkGreen,
            getValue: d => d.averageFirstWeekDonationDollars ?? 0,
          },
        ]}
        getXAxisValue={data => data.month.toString()}
        xAxisLabel="Campaign Start Month"
        xAxisTicks={4}
        yAxes={{
          averageDonation: {
            formatValue: value => formatDollars(value, 2),
            formatTick: value => formatDollars(value, 0),
            label: "Average Donation",
          },
        }}
        height={280}
      />
    </ChartContainer>
  );
}
